import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes} from '@angular/router';
import { AgentLocatorAgentdetailComponent } from './agentlocator/agent-locator-agentdetail/agent-locator-agentdetail.component';
import { StoreLocatorStoredetailComponent } from './mywallet/store/store-locator-storedetail/store-locator-storedetail.component';
import { AgentLocatorComponent } from './agentLocator/agentlocator.component';
import { DashBoardComponent } from './dash-board/dashboard-landingpage/dash-board.component';
import { MessagecentercontainerComponent } from './dash-board/messagecenter/messagecentercontainer/messagecentercontainer.component';
import { PaymentReceiptContainerDebitcardComponent } from './dash-board/paymernt-receipt-container/payment-receipt-container-debitcard/payment-receipt-container-debitcard.component';
import { PaymentReceiptContainerStoreComponent } from './dash-board/paymernt-receipt-container/payment-receipt-container-store/payment-receipt-container-store.component';
import { PaymentReceiptDebitcardindividualComponent } from './dash-board/shoppingcart/payment-receipt-debitcard/payment-receipt-debitcard-individual/payment-receipt-debitcard-individual.component';
// Cart
import { ShoppingcartlistComponent } from './dash-board/shoppingcart/shoppingcartlist/shoppingcartlist.component';
// My Wallet
import { CardlistComponent } from './mywallet/card/cardlist/cardlist.component';
import { StorelistComponent } from './mywallet/store/storelist/storelist.component';
import { StoremapComponent } from './mywallet/store/storemap/storemap.component';
import { WalletloyaltycardComponent } from './mywallet/walletloyaltycard/walletloyaltycard.component';
import { WalletoptionComponent } from './mywallet/walletoption/walletoption.component';
import { RepeatorderlistComponent } from './repeatorder/repeatorderlist/repeatorderlist.component';
import { AgentDetailsComponent } from './sendMoney/agent-details/agent-details.component';
import { DebitcardComponent } from './sendMoney/debitcard/debitcard.component';
// send Money
import { SendmoneyComponent } from './sendMoney/sendmoney.component';
import { StoreDetailsComponent } from './sendMoney/store-details/store-details.component';
import { AddAccountDetailComponent } from './sendMoney/_add-account-detail/add-account-detail.component';
import { BranchDetailsComponent } from './sendMoney/_branch-details/_branch-details.component';
import { BranchComponent } from './sendMoney/_branch/branch.component';
import { PayatstoreComponent } from './sendMoney/_payatstore/payatstore.component';
import { AuthGuard } from './sharedcomponents/_common/auth.guard';
import { DeactivateGuardService } from './sharedcomponents/_common/deactivate-guard.service';
import { SplashscreenComponent } from './sharedcomponents/_common/splashscreen/splashscreen.component';
//import { TransactionListUserComponent } from './transaction-history/transaction-list-user/transaction-list-user.component';
import { PayagainFailedorderComponent } from './transaction-history/payagain-failedorder/payagain-failedorder.component';
import { TransDebitCardComponent } from './transaction-history/trans-debit-card/trans-debit-card.component';
import { ForgetPasswordComponent } from './user/forget-password/forget-password.component';
import { LoginComponent } from './user/login/login.component';
import { UserEditProfileComponent } from './user/user-register/user-editprofile.component';
import { UserRegisterComponent } from './user/user-register/user-register.component';

export const rotuer: Routes = [
  { path: 'dashboard', component: DashBoardComponent, canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent },
  { path: 'register', component: UserRegisterComponent },
  { path: 'editprofile', component: UserEditProfileComponent, canActivate: [AuthGuard] }, //Path for profile Edit
  { path: 'forgetpassword', component: ForgetPasswordComponent },
  { path: 'pagenotfoundcomponent', component: ForgetPasswordComponent },
  // start send money
  { path: 'sendmoney', component: SendmoneyComponent, canActivate: [AuthGuard], canDeactivate: [DeactivateGuardService] },
  { path: 'sendmoneysummary', component: SendmoneyComponent, canActivate: [AuthGuard], canDeactivate: [DeactivateGuardService] },
  { path: 'repeatorder', component: SendmoneyComponent, canActivate: [AuthGuard] },
  { path: 'branches', component: BranchComponent, canActivate: [AuthGuard], canDeactivate: [DeactivateGuardService] },
  { path: 'branchedetails', component: BranchDetailsComponent, canActivate: [AuthGuard], canDeactivate: [DeactivateGuardService] },
  { path: 'agentdetails', component: AgentDetailsComponent, canActivate: [AuthGuard], canDeactivate: [DeactivateGuardService] },
  { path: 'bankdetails', component: AgentDetailsComponent, canActivate: [AuthGuard] },
  { path: 'storedetails', component: StoreDetailsComponent, canActivate: [AuthGuard], canDeactivate: [DeactivateGuardService] },
  { path: 'payatstorecart', component: PayatstoreComponent, canActivate: [AuthGuard] },
  { path: 'payatstore', component: PayatstoreComponent, canActivate: [AuthGuard], canDeactivate: [DeactivateGuardService] },
  { path: 'agentlocator', component: AgentLocatorComponent, canActivate: [AuthGuard] },
  { path: 'agentlocatoragentdetail', component: AgentLocatorAgentdetailComponent, canActivate: [AuthGuard] },
  { path: 'storelocatorstoredetail', component: StoreLocatorStoredetailComponent, canActivate: [AuthGuard] },
  { path: 'repeatorderlist', component: RepeatorderlistComponent, canActivate: [AuthGuard] },

  { path: 'addaccountdetail', component: AddAccountDetailComponent, canActivate: [AuthGuard], canDeactivate: [DeactivateGuardService] },

  // end send money
  //mywallet
  { path: 'mywallet', component: WalletoptionComponent, canActivate: [AuthGuard] },
  { path: 'mywalletcardlist', component: CardlistComponent, canActivate: [AuthGuard] },
  { path: 'mywalletstorelist', component: StorelistComponent, canActivate: [AuthGuard] },
  { path: 'mywalletstorelistloyaltycard', component: WalletloyaltycardComponent, canActivate: [AuthGuard] },
  //Cart
  { path: 'shoppingcart', component: ShoppingcartlistComponent, canActivate: [AuthGuard] },
  //Exchange Rate
  //{ path: 'exchangerate', component: ExchangeRateComponent, canActivate: [AuthGuard] },
  { path: 'exchangerate', component: SendmoneyComponent, canActivate: [AuthGuard] },

  // { path: 'debitcard', component: DebitcardComponent, canActivate: [AuthGuard] },
  { path: 'debitcard', component: DebitcardComponent, canActivate: [AuthGuard], canDeactivate: [DeactivateGuardService] },
  { path: 'Storemap', component: StoremapComponent, canActivate: [AuthGuard] },

  { path: 'transdebitcard', component: TransDebitCardComponent, canActivate: [AuthGuard] },
  { path: 'payagaintrans', component: PayagainFailedorderComponent, canActivate: [AuthGuard] },

  { path: 'PaymentReceipt', component: PaymentReceiptContainerDebitcardComponent, canActivate: [AuthGuard] },
  { path: 'PaymentReceiptDebitcard', component: PaymentReceiptContainerDebitcardComponent, canActivate: [AuthGuard] },
  { path: 'PaymentReceiptDebitcardindividual', component: PaymentReceiptDebitcardindividualComponent, canActivate: [AuthGuard] },
  { path: 'PaymentReceiptStore', component: PaymentReceiptContainerStoreComponent, canActivate: [AuthGuard] },
  // { path: 'Sharepromotionalcode', component: SharepromotionalcodecontainerComponent, canActivate: [AuthGuard] },
  { path: 'messagecenter', component: MessagecentercontainerComponent, canActivate: [AuthGuard] },
  {
    path: 'repeatorderlistmain',
    loadChildren: './repeatorder/repeatorder-routing.module#repeatorderModule'
  },
  // { path: 'repeatorderlistdashboard', component: RepeatorderlistComponent, canActivate: [AuthGuard] },
  // { path: 'repeatorderlisttrans', component: RepeatorderlistComponent, canActivate: [AuthGuard] },
  {
    path: 'transactionlist',
    loadChildren: './transaction-history/transaction-routing.module#transactionhistoryModule'
  },
  { path: '404', component: LoginComponent },
  { path: '**', component: SplashscreenComponent }
];
export const routes: ModuleWithProviders = RouterModule.forRoot(rotuer);



// WEBPACK FOOTER //
// ./src/app/app.route.ts